import { MapPin } from "lucide-react";
import { IMAGES, OFFER, WA_MESSAGES } from "@/config/business";
import { CallButton, WhatsAppButton } from "./CtaButtons";

const Hero = () => (
  <section id="home" className="relative flex min-h-[92vh] items-center overflow-hidden">
    <img
      src={IMAGES.hero.src}
      alt={IMAGES.hero.alt}
      className="absolute inset-0 h-full w-full object-cover"
      fetchPriority="high"
      decoding="async"
    />
    <div
      className="absolute inset-0 bg-gradient-to-b from-[#1C1917]/85 via-[#1C1917]/60 to-[#1C1917]/85"
      aria-hidden="true"
    />
    <div className="relative z-10 mx-auto w-full max-w-4xl px-5 pb-20 pt-28 text-center sm:px-8">
      <p
        data-testid="hero-offer-eyebrow"
        className="animate-fade-up mx-auto inline-flex items-center gap-2 rounded-full border border-[#EED8A1]/40 bg-[#C5A059]/15 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#EED8A1] sm:text-xs"
      >
        <span className="pulse-dot inline-block h-1.5 w-1.5 rounded-full bg-[#EED8A1]" aria-hidden="true" />
        {OFFER.eyebrow}
      </p>

      <h1 className="animate-fade-up delay-100 mt-6 font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
        Relax. Rejuvenate. Feel Your Best.
      </h1>

      <p className="animate-fade-up delay-200 mt-4 font-serif text-xl italic text-[#EED8A1] sm:text-2xl">
        GK Wellness &amp; Luxury Spa
      </p>

      <p className="animate-fade-up delay-200 mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-stone-200 sm:text-base">
        Experience a relaxing wellness journey with a selection of massage and spa experiences in
        Singasandra, near Manipal County Road, Bengaluru.
      </p>

      <p
        data-testid="hero-discount-badge"
        className="animate-fade-up delay-300 mt-6 inline-block rounded-full bg-[#C5A059] px-6 py-2.5 font-serif text-lg font-semibold tracking-wide text-[#1C1917] shadow-[0_8px_30px_-4px_rgba(197,160,89,0.6)] sm:text-xl"
      >
        {OFFER.discount}
      </p>

      <div className="animate-fade-up delay-300 mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
        <WhatsAppButton
          message={WA_MESSAGES.hero}
          label="Book on WhatsApp"
          testId="hero-whatsapp-cta"
          size="lg"
          className="w-full sm:w-auto"
        />
        <CallButton
          label="Call 8050533116"
          testId="hero-call-cta"
          size="lg"
          variant="onDark"
          className="w-full sm:w-auto"
        />
      </div>

      <p className="animate-fade-up delay-400 mt-8 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-stone-300">
        <MapPin className="h-4 w-4 text-[#EED8A1]" aria-hidden="true" />
        Singasandra, Bengaluru
        <span className="text-stone-500" aria-hidden="true">•</span>
        Near Manipal County Road
      </p>
    </div>
  </section>
);

export default Hero;
